import {isClient, isNonProduction} from 'hec/utils/common'
import {resolveAaidAffiliate} from './resolveAaid'
import {TpaGroupNames, TpaUrlParamIdentifiers} from './types'

export const getExpiryDateAndTimeForTpaCookies = (groupName: string) => {
    const currentTimestamp = Date.now()

    const days = groupName === TpaGroupNames.TPA ? 365 : 30
    const expiryDate = new Date(currentTimestamp + days * 24 * 60 * 60 * 1000)
    const expiryMs = expiryDate.getTime()

    return {
        expiryDate,
        expiryMs
    }
}

export const getTpaParamsFromUrl = (options?: {resolveAffiliate?: boolean}) => {
    if (!isClient) return null

    const searchParams = new URLSearchParams(window.location.search)
    // Check for both uppercase and lowercase AFID parameters
    let afid = searchParams.get(TpaUrlParamIdentifiers.AFID) || searchParams.get('afid') || ''
    let groupName = searchParams.get(TpaUrlParamIdentifiers.GROUP_NAME)?.toLowerCase() || ''
    let cid = searchParams.get(TpaUrlParamIdentifiers.CID) || ''
    const parentId = searchParams.get(TpaUrlParamIdentifiers.PARENT_ID) || ''

    // Legacy affiliate links carry `a_aid` (a PAP hash) instead of a numeric
    // AFID; SFRA resolves it, composable did not, so these links dropped the
    // attribution cookie after 100% composable (SFCC-11532). Resolve ONLY for
    // the revenue-tracking caller (`resolveAffiliate`) — branding is keyed on
    // `GroupName` and SFRA sets no partner branding for `a_aid` affiliates.
    if (options?.resolveAffiliate && !afid) {
        const aid = searchParams.get('a_aid') || ''
        const resolved = aid ? resolveAaidAffiliate(aid, !isNonProduction) : null
        if (resolved) {
            afid = resolved.afid
            groupName = resolved.groupName
            cid = resolved.cid
        }
    }

    if (!afid && !groupName && !cid && !parentId) {
        return
    }

    return {
        afid,
        groupName,
        cid,
        parentId
    }
}
